<footer class="bg-[#02030f] text-white w-full">
  <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
    <!-- Top Section: Logo, Social Icons, and Links -->
    <div class="mb-8 sm:mb-12">
      <div class="flex flex-col lg:flex-row justify-between items-start gap-8 lg:gap-12">
        <!-- Logo and Social Icons -->
        <div class="flex flex-col gap-4 sm:gap-6 lg:min-w-[280px]">
          <div class="flex items-center gap-2 footer-logo-enter">
            <img src="assets/icons/footer/scripay_logo.svg" alt="ScriPay Logo" class="h-auto">
          </div>
          <p class="text-footer-text-muted text-sm footer-copyright-enter">
            Copyright © {{ currentYear }} - ScriPay
          </p>
          <div class="flex gap-3 flex-wrap">
            <a *ngFor="let social of socialLinks; let i = index" 
               [href]="social.href" 
               [attr.target]="social.external ? '_blank' : null"
               [attr.rel]="social.external ? 'noopener noreferrer' : null" 
               class="w-10 h-10 rounded-full bg-social-bg hover:bg-social-hover flex items-center justify-center transition-all duration-300 hover:scale-110 hover:-translate-y-1 active:scale-95 social-icon-enter"
               [style.animation-delay]="(i * 50) + 'ms'"
               [attr.aria-label]="social.label">
              <img [src]="social.icon" [alt]="social.alt" class="w-5 h-5" />
            </a>
          </div>
        </div>

        <!-- Navigation Links -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-12 flex-1 w-full lg:w-auto">
          <div *ngFor="let column of navigationLinks; let colIndex = index" 
               class="flex flex-col gap-3 footer-nav-column-enter"
               [style.animation-delay]="(colIndex * 100) + 'ms'">
            <ng-container *ngFor="let link of column.items">
              <!-- Internal routes -->
              <a *ngIf="link.routerLink; else externalLink" 
                 [routerLink]="link.routerLink"
                 class="text-footer-text-muted hover:text-footer-text active:text-footer-text cursor-pointer transition-all duration-300 text-sm footer-link">
                {{ link.label }}
              </a>

              <!-- External links -->
              <ng-template #externalLink>
                <a [href]="link.href"
                   [attr.target]="link.href && !link.href.startsWith('/') ? '_blank' : null"
                   [attr.rel]="link.href && !link.href.startsWith('/') ? 'noopener noreferrer' : null"
                   class="text-footer-text-muted hover:text-footer-text active:text-footer-text cursor-pointer transition-all duration-300 text-sm footer-link">
                  {{ link.label }}
                </a>
              </ng-template>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Section: Why Scripay -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
      <div *ngFor="let section of whyScripaySections; let i = index" 
           class="footer-section-enter"
           [style.animation-delay]="(i * 150) + 'ms'">
        <h3 class="text-lg sm:text-xl font-semibold mt-4 sm:mt-6 mb-2">
          {{ section.title }}
        </h3>
        <p class="text-muted-foreground text-sm leading-relaxed">
          {{ section.description }}
        </p>
      </div>
    </div>
  </div>
</footer>